import { useState } from "react";
import SectionHeading from "./SectionHeading";
import { weekdaySchedule, weekendSchedule } from "@/mocks/schedule";

const tabs = [
  { key: "weekday", label: "周一至周四" },
  { key: "weekend", label: "周五至周日" },
];

export default function TheaterSchedule() {
  const [active, setActive] = useState("weekday");
  const rows = active === "weekday" ? weekdaySchedule : weekendSchedule;

  return (
    <section id="theater" className="scroll-mt-20 bg-secondary-950 px-4 md:px-8 py-16 md:py-24">
      <div className="max-w-5xl mx-auto">
        <div className="max-w-3xl">
          <div className="flex items-center gap-3">
            <span className="h-px w-8 bg-accent-500" />
            <span className="font-label text-xs tracking-[0.35em] text-accent-300 uppercase">
              Nostalgia Theater
            </span>
          </div>
          <h2 className="mt-4 font-heading text-2xl md:text-3xl lg:text-4xl font-bold leading-snug text-background-50">
            怀旧剧场 · 一日排片参考
          </h2>
          <p className="mt-4 text-sm md:text-base leading-relaxed text-background-300">
            下面是一份示例性的怀旧剧场排片，按时间顺序组合不同年代与类型的作品。你可以据此安排一场有节奏的老片观影，也可以只挑其中一两场。
          </p>
        </div>

        <div className="mt-8 md:mt-10 inline-flex items-center gap-1 p-1 rounded-full bg-background-50/10 border border-background-100/20">
          {tabs.map((tab) => (
            <button
              key={tab.key}
              type="button"
              onClick={() => setActive(tab.key)}
              className={`px-4 py-2 rounded-full text-sm font-label whitespace-nowrap transition-colors ${
                active === tab.key
                  ? "bg-accent-500 text-secondary-950"
                  : "text-background-100 hover:text-accent-100"
              }`}
            >
              {tab.label}
            </button>
          ))}
        </div>

        <div className="mt-6 space-y-3">
          {rows.map((row) => (
            <div
              key={`${row.time}-${row.title}`}
              className="flex flex-col md:flex-row md:items-center gap-3 md:gap-6 rounded-lg border border-background-100/15 bg-background-50/5 p-4 md:p-5"
            >
              <div className="flex items-center gap-3 md:w-28 shrink-0">
                <span className="font-heading text-xl md:text-2xl font-bold text-accent-300">
                  {row.time}
                </span>
              </div>
              <span className="hidden md:block w-px h-12 bg-background-100/20" />
              <div className="flex-1">
                <div className="flex flex-wrap items-center gap-2">
                  <h3 className="font-heading text-base md:text-lg font-semibold text-background-50">
                    {row.title}
                  </h3>
                  <span className="px-2 py-0.5 rounded-full bg-primary-500/30 text-primary-100 text-[11px] font-label">
                    {row.year}
                  </span>
                </div>
                <p className="mt-1.5 text-xs md:text-sm text-background-300">
                  {row.hall} · {row.era}
                </p>
              </div>
              <div className="flex items-center gap-4 md:gap-6 text-xs md:text-sm text-background-200 font-label">
                <span className="inline-flex items-center gap-1 whitespace-nowrap">
                  <i className="ri-time-line" />
                  {row.duration}
                </span>
                <span className="px-2.5 py-1 rounded-full bg-background-50/10 text-accent-100 whitespace-nowrap">
                  {row.tag}
                </span>
              </div>
            </div>
          ))}
        </div>

        <p className="mt-6 flex items-start gap-2 text-xs md:text-sm text-background-400">
          <i className="ri-information-line mt-0.5" />
          以上排片为内容导览示例，用于说明一天内的观影组合方式，实际安排可依个人时间调整。
        </p>
      </div>
    </section>
  );
}